import Loading from 'components/Loading/Loading';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  selectEmployerAllowancesWithDraftsArray,
  selectIsEmployerAllowancesFetchPending,
} from 'store/employerAllowances/selectors/employerAllowances.selectors';
import { EmployerAllowanceEditItem } from './EmployerAllowanceEditItem';

export const EmployerAllowances = () => {
  const employerAllowanceMergedWithDrafts = useSelector(
    selectEmployerAllowancesWithDraftsArray
  );

  const isLoadingEmployerAllowances = useSelector(
    selectIsEmployerAllowancesFetchPending
  );

  return !isLoadingEmployerAllowances ? (
    <>
      {employerAllowanceMergedWithDrafts.map((employerAllowance) => (
        <EmployerAllowanceEditItem
          employerAllowance={employerAllowance}
          key={employerAllowance.id}
        />
      ))}
    </>
  ) : (
    <Loading tiny />
  );
};
